import {fromJS} from 'immutable'

import {
  VIEWPORT_TYPES,
  VIEWPORT_MAX_WIDTH_PHONE
} from '../../config/constants'

const {PHONE, DESKTOP} = VIEWPORT_TYPES

import {
  SET_VIEWPORT_DIMENSIONS
} from '../action_types'

export default (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_VIEWPORT_DIMENSIONS:
      const {width, height} = action
      const type = width > VIEWPORT_MAX_WIDTH_PHONE ? DESKTOP : PHONE

      state = state.set('width', width)
      state = state.set('height', height)
      state = state.set('type', type)

      return state

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/viewport.js
 **/